import React from 'react';
import { SvgLunker } from './svg_lunker';

export const LunkerPotential = () => {
  return (
    <span className="bg-[#6B71721C] rounded-full font-medium px-3 p-1 text-[10px] leading-normal flex items-center gap-1">
      <SvgLunker /> Lunker Potential
    </span>
  );
};
